import { StyleSheet } from 'react-native';
import { pt, px } from '../common/utils';

export default StyleSheet.create({
    container: {
        position: 'relative',
        backgroundColor: '#F5F5F5',
        flex: 1
    },
    top_wrap: {
        height: pt(80),
        paddingLeft: pt(35),
        paddingRight: pt(20),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    pt15: {
        paddingTop: pt(15)
    },
    flex_row: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    jd_bean: {
        width: pt(23),
        height: pt(21)
    },
    top_num: {
        paddingLeft: pt(8),
        fontSize: pt(24),
        color: '#FFFFFF'
    },
    top_txt: {
        fontSize: pt(12),
        color: '#FFFFFF',
        paddingTop: pt(5)
    },
    btn: {
        justifyContent: 'center',
        alignItems: 'center',
        width: pt(64),
        height: pt(30),
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        borderRadius: pt(15)
    },
    abs: {
        position: 'absolute',
        top: pt(25),
        right: pt(18)
    },
    top25: {
        top: pt(23)
    },

    btn_txt: {
        fontSize: pt(12),
        color: '#F40600'
    },
    active_tab: {
        fontSize: pt(13),
        color: '#FC1B00'
    },
    inactive_tab: {
        fontSize: pt(13),
        color: '#333333'
    },
    record_wrap: {
        paddingHorizontal: pt(16),
        borderTopColor: 'rgba(0,0,0,0.1)',
        borderTopWidth: px(1),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: pt(15),
        backgroundColor: '#FFFFFF'
    },
    font_bold: {
        color: '#252525',
        fontSize: pt(14)
    },
    font_light: {
        color: '#999999',
        fontSize: pt(12),
        marginTop: pt(2)
    },
    font_color: {
        color: '#FC1B00',
        fontSize: pt(15)
    },
    font_green: {
        color: '#12B72B'
    },
    nomore_wrap: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: pt(15)
    },
    nomore_txt: {
        color: '#BBBBBB',
        fontSize: pt(12)
    },
    content_wrap: {
        paddingVertical: pt(16)
    },
    input_wrap: {
        borderWidth: px(1),
        borderColor: '#BBBBBB',
        width: pt(230),
        height: pt(40),
        marginTop: pt(10),
        color: pt(13),
        paddingHorizontal: pt(10)
    },
    alert_msg: {
        paddingTop: pt(9),
        width: pt(228),
        fontSize: pt(12),
        color: '#666666'
    },
    content_tab: {
        width: pt(230),
        height: pt(30),
        borderRadius: pt(4),
        backgroundColor: '#F0F0F0',
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: pt(3)
    },
    tab: {
        height: pt(24),
        borderRadius: pt(4),
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    tab_cur: {
        backgroundColor: '#FFFFFF'
    },
    err_txt: {
        fontSize: pt(12),
        color: '#F30300',
        paddingTop: pt(6)
    }
});
